import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";

const state = () => ({
  messages: [],
  newRecordsCount: {
    total: 0,
  },
  responsesCount: {
    total: 0,
  },
  contactingRecordsCount: {
    pastDue: 0,
    dueToday: 0
  },
  followUpRecordsCount: {
    pastDue: 0,
    dueToday: 0
  },
  activeRecordsCount: {
    pastDue: 0,
    dueToday: 0
  },
})

const getters = {
  newRecordsCount(state) {
    return state.newRecordsCount.total
  },
  responsesCount(state) {
    return state.responsesCount.total
  },
  contactingBadges(state) {
    return state.contactingRecordsCount
  },
  followUpBadges(state) {
    return state.followUpRecordsCount
  },
  activeBadges(state) {
    return state.activeRecordsCount
  },
};

const mutations = {
  setup(state, data) {
    state.newRecordsCount = data.newRecordsCount;
    state.responsesCount = data.responsesCount;
    state.contactingRecordsCount = data.contactingRecordsCount
    state.followUpRecordsCount = data.followUpRecordsCount
    state.activeRecordsCount = data.activeRecordsCount
  },
  setMessages(state, messages) {
    state.messages = messages;
  },
  teardown(state) {
    state.messages = []
    state.newRecordsCount = {total: 0};
    state.responsesCount = {total: 0};
    state.contactingRecordsCount = {
      pastDue: 0,
      dueToday: 0
    }
    state.followUpRecordsCount = {
      pastDue: 0,
      dueToday: 0
    }
    state.activeRecordsCount = {
      pastDue: 0,
    }
  },
};

const actions = {
  setup({commit, state, rootState, getters, rootGetters}) {
    subscribeToChannel("dashboard", rootState.activeUser.id);
    subscribeToChannel("market.events", rootGetters.market.id)

    const initBadges = api.clientStore.initDashboardBadges(rootState.activeUser.id)
    const getCustomerMessages = api.customerMessages.all();
    return Promise.all([initBadges, getCustomerMessages])
      .then(([badges, messages]) => {
        commit('setup', badges.data);
        commit('setMessages', messages.data);
      });
  },
  tearDown({commit, state, rootState, getters, dispatch, rootGetters}) {
    unsubscribeToChannel("dashboard", rootState.activeUser.id)
    unsubscribeToChannel("market.events", rootGetters.market.id)

    commit('teardown')
  },
};

const DashboardStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default DashboardStore;
